var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConsequences(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 12,
    viewBox: "0 0 13 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12.5 0.599609H11.3C10.97 0.599609 10.7 0.869609 10.7 1.19961V6.59961C10.7 6.92961 10.97 7.19961 11.3 7.19961H12.5V0.599609ZM0.602 4.87161C0.536 5.02161 0.5 5.18361 0.5 5.35161V5.99961C0.5 6.65961 1.04 7.19961 1.7 7.19961H5L4.448 9.98961C4.418 10.1216 4.436 10.2656 4.496 10.3856C4.634 10.6556 4.808 10.9016 5.024 11.1176L5.3 11.3996L9.146 7.55361C9.374 7.32561 9.5 7.01961 9.5 6.70161V2.00361C9.5 1.22961 8.87 0.599609 8.096 0.599609H3.236C2.81 0.599609 2.42 0.821609 2.204 1.18161L0.602 4.87161Z",
    fill: "#EF4444"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConsequences);
export default __webpack_public_path__ + "static/media/consequences.758a76cef64134f4035d5e8da5c735bd.svg";
export { ForwardRef as ReactComponent };